import type { JSX } from 'react';
import { DateTime } from '@ksyos/date-time';
import { Divider, FormSection, Link, Text } from '@ksyos/design-system';
import type { IEmploymentTaxesDetails } from '@common/interfaces/employmentTaxesDetails';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import { getSelectedLanguage } from '@frontend/translate';
import { getCountryOption } from '@frontend/utils/getCountryOption';

interface IEmploymentTaxesDetailsProps {
    employmentTaxesDetails: IEmploymentTaxesDetails;
    isManager: boolean;
}

export function EmploymentTaxesDetailsRead(props: Readonly<IEmploymentTaxesDetailsProps>): JSX.Element {
    return (
        <>
            <Text marginBottom={6}>{getSelectedLanguage().employmentTaxesDetails.naturalPersonQuestion}</Text>
            <FormParagraphFormGroup label={getSelectedLanguage().employmentTaxesDetails.isNaturalPersonLabel}>
                {props.employmentTaxesDetails.isNaturalPerson ? 'Ja' : 'Nee'}
            </FormParagraphFormGroup>
            {!props.isManager && props.employmentTaxesDetails.isNaturalPerson && (
                <>
                    <Divider />

                    <FormSection title="Persoonsgegevens">
                        <Text marginBottom={6}>
                            {getSelectedLanguage().employmentTaxesDetails.personalDataInfoFirstPart}
                            <Link
                                color="minimal"
                                href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/zakelijk/personeel_en_loon/uitbetaalde_bedragen_aan_derden/"
                                openInNewTab={true}
                                variant="externalLink"
                            >
                                {getSelectedLanguage().employmentTaxesDetails.personalDataInfoLink}
                            </Link>
                            {getSelectedLanguage().employmentTaxesDetails.personalDataInfoSecondPart}
                        </Text>

                        <FormParagraphFormGroup label={getSelectedLanguage().common.bsn}>
                            {props.employmentTaxesDetails.identifierSocialSecurity}
                        </FormParagraphFormGroup>

                        <FormParagraphFormGroup label={getSelectedLanguage().common.birthDate}>
                            {DateTime.from(props.employmentTaxesDetails.birthDate!).format('DD-MM-YYYY')}
                        </FormParagraphFormGroup>
                    </FormSection>

                    <FormSection title="Postadres of woonadres">
                        <FormParagraphFormGroup label={getSelectedLanguage().common.streetAndHouseNumber}>
                            {props.employmentTaxesDetails.street} {props.employmentTaxesDetails.houseNumber}{' '}
                            {props.employmentTaxesDetails.houseNumberSuffix}
                        </FormParagraphFormGroup>

                        <FormParagraphFormGroup label={getSelectedLanguage().common.zipcodeAndCity}>
                            {props.employmentTaxesDetails.zip} {props.employmentTaxesDetails.city}
                        </FormParagraphFormGroup>

                        <FormParagraphFormGroup label={getSelectedLanguage().common.country}>
                            {getCountryOption(props.employmentTaxesDetails.country)!.label}
                        </FormParagraphFormGroup>
                    </FormSection>
                </>
            )}
        </>
    );
}
